import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const PaySuccess = () => {
  const [searchParams] = useSearchParams();
  const isCancelled = searchParams.get("state") === "cancel";
  return (
    <>
      <div className="successDiv">
        <div className="success-container">
          <div className="modal-content">
            <div className={`checkmark-circle ${isCancelled ? "is-cancelled" : ""}`}>
              <FontAwesomeIcon icon={faCheck} />
              <div className="checkmark"></div>
            </div>
            <p>{isCancelled ? "Payment was cancelled." : "Payment successful. Thank you for your order."}</p>
            <Link to={isCancelled ? "/checkout" : "/shop"}>
              {isCancelled ? "Return to checkout" : "Continue shopping"}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaySuccess;
